export default __webpack_public_path__ + "static/media/green_v2.a00e7c46.png";